import { useEffect, useRef, useState } from 'react'
import { Close, HelpOutline } from '@mui/icons-material'
import './contextual-help.style.scss'

const ContextualHelp = ({ title, summary, items, tips, className = '' }) => {
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef(null)

  useEffect(() => {
    if (!isOpen) {
      return undefined
    }

    const handleClickOutside = event => {
      if (!containerRef.current?.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  return (
    <div ref={containerRef} className={`contextual-help ${className}`.trim()}>
      <button
        className="contextual-help__trigger"
        type="button"
        onClick={() => setIsOpen(current => !current)}
        aria-label="Como usar"
        title="Como usar"
      >
        <HelpOutline fontSize="inherit" />
      </button>

      {isOpen && (
        <aside className="contextual-help__panel">
          <div className="contextual-help__panel__header">
            <strong>{title}</strong>
          </div>

          <p className="contextual-help__summary">{summary}</p>

          <div className="contextual-help__section">
            {items.map(item => (
              <p key={item.title}>
                <strong>{item.title}:</strong> {item.description}
              </p>
            ))}
          </div>

          {!!tips?.length && (
            <div className="contextual-help__section contextual-help__section--tips">
              {tips.map(tip => (
                <p key={tip}>{tip}</p>
              ))}
            </div>
          )}
        </aside>
      )}
    </div>
  )
}

export { ContextualHelp }
